import { AuthError } from '@juvare/platform-app/App';
export const additionalOrgPermissionPublicDataKey = 'additionalOrgPermission';
export function allowAccessToUserDirectory(userState) {
    return requireAnySystemPermission(userState, 'view-user-directory');
}
export function allowAccessToAccounts(userState) {
    return (requireAnySystemPermission(userState, 'manage-accounts', 'list-all-accounts') ||
        requireAnyOrgPermission(userState, 'view-members', 'view-and-message-members', 'create-notifications', 'view-and-transfer-members', 'manage-members'));
}
export function allowAccessToPendingMemberships(userState) {
    return requireAnySystemPermission(userState, 'manage-accounts') || requireAnyOrgPermission(userState, 'manage-members');
}
export function allowAccessToGroups(userState) {
    return (requireAnySystemPermission(userState, 'manage-groups') ||
        requireAnyOrgPermission(userState, 'view-and-message-members', 'create-notifications', 'manage-members'));
}
export function allowOrgMembersEdit(userState) {
    return requireAnySystemPermission(userState, 'manage-accounts') || requireAnyOrgPermission(userState, 'manage-members');
}
export function allowCreateGroup(userState) {
    return (requireAnySystemPermission(userState, 'manage-groups') ||
        requireAnyOrgPermission(userState, 'manage-members', 'view-and-message-members', 'create-notifications'));
}
export function allowAccessToNotifications(userState) {
    return (requireAnySystemPermission(userState, 'manage-notifications') ||
        requireAnyOrgPermission(userState, 'view-and-message-members', 'create-notifications'));
}
export function allowUserSendMessagesAccountSlideout(userState, orgIds) {
    const orgPermission = !!(orgIds === null || orgIds === void 0 ? void 0 : orgIds.some((orgId) => requireOrgPermission(userState, orgId, 'view-and-message-members', 'create-notifications')));
    return requireAnySystemPermission(userState, 'manage-notifications') || orgPermission;
}
export function allowUserSendMessages(userState) {
    return (requireAnySystemPermission(userState, 'manage-notifications') ||
        requireAnyOrgPermission(userState, 'view-and-message-members', 'create-notifications'));
}
export function allowSwitchUser(userState) {
    return requireAnySystemPermission(userState, 'switch-to-account');
}
export function allowCopyPassword(userState) {
    return (requireAnySystemPermission(userState, 'switch-to-account') &&
        ((userState === null || userState === void 0 ? void 0 : userState.environment) === 'dev' || (userState === null || userState === void 0 ? void 0 : userState.environment) === 'lab' || (userState === null || userState === void 0 ? void 0 : userState.environment) === 'local'));
}
/**
 * Filter that is used to gather accounts that user can actually edit in the table
 */
export function getAccountsManageFilter(userState) {
    if (!userState) {
        throw new Error('Unauthorized');
    }
    const filters = [{ column: 'systemStatus', op: '!=', value: 'deleted' }];
    if (!requireAnySystemPermission(userState, 'view-system-admin-accounts')) {
        filters.push({ column: 'systemRole', op: '!=', value: 'system-admin' });
    }
    if (requireAnySystemPermission(userState, 'manage-accounts')) {
        return filters;
    }
    const orgIds = collectOrgIdsForAnyOrgPermission(userState, 'manage-members');
    const orgFilters = {
        op: 'or',
        filter: [
            { column: 'orgMembership', op: 'overlap', value: orgIds },
            { column: 'orgAssociation', op: 'overlap', value: orgIds },
        ],
    };
    return [...filters, orgFilters];
}
/**
 * @deprecated - use getAccountsViewFilterNew instead
 */
export function getAccountsViewFilter(userState, includeInactiveAccounts) {
    if (userState) {
        const activeAccountsFilter = includeInactiveAccounts ? [] : getActiveAccountsFilter(userState);
        if (requireAnySystemPermission(userState, 'list-all-accounts')) {
            return activeAccountsFilter;
        }
        const orgMembershipFilter = {
            column: 'orgMembership',
            op: 'overlap',
            value: collectOrgIdsForAnyOrgPermission(userState, 'view-members', 'view-and-message-members', 'create-notifications', 'view-and-transfer-members', 'manage-members'),
        };
        const orgAssociationFilter = {
            column: 'orgAssociation',
            op: 'overlap',
            value: collectOrgIdsForAnyOrgPermission(userState, 'manage-members'),
        };
        return [{ op: 'or', filter: [orgMembershipFilter, orgAssociationFilter] }, ...activeAccountsFilter];
    }
    else {
        throw new Error('Unauthorized');
    }
}
/**
 * This filter is mainly used for listing accounts, meaning user can see an account in the table.
 * This filter does not mean that user has edit rights to particular account.
 * For editing more strict filter must be used such as `getAccountsManageFilter`
 */
export function getAccountsViewFilterNew(userState, showAllAccounts) {
    if (!userState) {
        throw new Error('Unauthorized');
    }
    const filters = [{ column: 'systemStatus', op: '!=', value: 'deleted' }];
    if (!requireAnySystemPermission(userState, 'view-system-admin-accounts')) {
        filters.push({ column: 'systemRole', op: '!=', value: 'system-admin' });
    }
    if (requireAnySystemPermission(userState, 'list-all-accounts') || showAllAccounts) {
        return filters;
    }
    const orgAssociationValues = collectOrgIdsForAnyOrgPermission(userState, 'manage-members');
    const orgMembershipValues = collectOrgIdsForAnyOrgPermission(userState, 'view-members', 'view-and-message-members', 'create-notifications', 'view-and-transfer-members', 'manage-members');
    const orgFilters = {
        op: 'or',
        filter: [
            { column: 'orgAssociation', op: 'overlap', value: orgAssociationValues },
            { column: 'orgMembership', op: 'overlap', value: orgMembershipValues },
        ],
    };
    return [...filters, orgFilters];
}
/**
 * Filter that is used to gather accounts that user can massage them.
 */
export function getAccountsMessageMembersFilter(userState) {
    if (userState) {
        const activeAccountsFilter = getActiveAccountsFilter(userState);
        if (requireAnySystemPermission(userState, 'list-all-accounts')) {
            return activeAccountsFilter;
        }
        const orgMembershipFilter = {
            column: 'orgMembership',
            op: 'overlap',
            value: collectOrgIdsForAnyOrgPermission(userState, 'view-and-message-members', 'create-notifications'),
        };
        return [orgMembershipFilter, ...activeAccountsFilter];
    }
    else {
        throw new Error('Unauthorized');
    }
}
/**
 * Low level filter for listing active account, usually it is used by higher level filters above
 */
export function getActiveAccountsFilter(userState) {
    if (userState) {
        return [{ column: 'systemStatus', op: '=', value: 'active' }];
    }
    else {
        throw new Error('Unauthorized');
    }
}
export function requireAnySystemPermission(userState, ...requireAnyPermissions) {
    var _a;
    for (const requireAnyPermission of requireAnyPermissions) {
        if ((_a = userState === null || userState === void 0 ? void 0 : userState.systemPermissions) === null || _a === void 0 ? void 0 : _a.includes(requireAnyPermission)) {
            return true;
        }
    }
    return false;
}
function checkOrgPermissions(orgPermissions, ...requireAnyPermissions) {
    return Object.values(orgPermissions).some((permissions) => requireAnyPermissions.some((required) => permissions.includes(required)));
}
export function requireAnyOrgPermission(userState, ...requireAnyPermissions) {
    if (!userState)
        return false;
    if (requireAnySystemPermission(userState, 'all-organizations-admin')) {
        return true;
    }
    return checkOrgPermissions(userState.orgPermissions, ...requireAnyPermissions);
}
export function collectOrgIdsForAnyOrgPermission(userState, ...requireAnyPermissions) {
    const orgIds = [];
    if (userState) {
        for (const [orgId, permissions] of Object.entries(userState.orgPermissions)) {
            for (const requireAnyPermission of requireAnyPermissions) {
                if (permissions.includes(requireAnyPermission)) {
                    orgIds.push(orgId);
                    break;
                }
            }
        }
    }
    return orgIds;
}
export function requireOrgPermission(userState, orgId, ...requireAnyPermissions) {
    if (userState && orgId && requireAnyPermissions) {
        if (requireAnySystemPermission(userState, 'all-organizations-admin')) {
            return true;
        }
        const permissions = userState.orgPermissions[orgId];
        if (!permissions) {
            return false;
        }
        for (const requireAnyPermission of requireAnyPermissions) {
            if (permissions.includes(requireAnyPermission)) {
                return true;
            }
        }
    }
    return false;
}
export function getRolesHavingPermission(orgRoleMap, permission) {
    return Object.entries(orgRoleMap)
        .filter(([, { permissions }]) => permissions.includes(permission))
        .map(([orgRole]) => orgRole);
}
export function getRolesHavingPermissions(map, permissionsArray) {
    return Object.entries(map)
        .filter(([, { permissions }]) => permissionsArray.some((permission) => permissions.includes(permission)))
        .map(([orgRole]) => orgRole);
}
export function getOrganizationIdsWithRoleHavingPermission(organizationIds, orgRoleMap, permission) {
    const organizationIdsWithRole = [];
    const orgRoles = getRolesHavingPermission(orgRoleMap, permission);
    for (const organizationId of organizationIds) {
        for (const orgRole of orgRoles) {
            organizationIdsWithRole.push(organizationId + '_' + orgRole);
        }
    }
    return organizationIdsWithRole;
}
// TODO check functions below
export function getOrganizationsMessengerFilter(userState) {
    return requireAnySystemPermission(userState, 'manage-organizations', 'all-organizations-admin')
        ? []
        : [{ id: collectOrgIdsForAnyOrgPermission(userState, 'view-and-message-members', 'create-notifications'), op: 'in' }];
}
export function getGroupFilter(userState, selectedGroupId) {
    if (requireAnySystemPermission(userState, 'manage-groups')) {
        if (selectedGroupId !== undefined) {
            return [{ id: selectedGroupId, op: '!=' }];
        }
        return [];
    }
    else {
        const groupFilter = {
            op: 'or',
            filter: [{ column: 'ownerAccountId', op: '=', value: userState.id }],
        };
        const orgIds = collectOrgIdsForAnyOrgPermission(userState, 'view-and-message-members', 'create-notifications', 'manage-members');
        if (orgIds.length > 0) {
            groupFilter.filter.push({ column: 'visibleToAnyAdmin', op: '=', value: true });
        }
        if (orgIds.length > 0) {
            groupFilter.filter.push({ column: 'visibleToOrgAdmins', op: 'overlap', value: orgIds });
        }
        return selectedGroupId ? [groupFilter, { id: selectedGroupId, op: '!=' }] : [groupFilter];
    }
}
export function checkAssignedOrganizations(organizations, idsToSave) {
    const includesMissingOrganizations = idsToSave.some((orgId) => !organizations[orgId]);
    if (includesMissingOrganizations) {
        throw new AuthError('Organization does not exist');
    }
}
export function findDefaultRoleKey(roles) {
    var _a;
    const [roleKey] = (_a = Object.entries(roles).find(([, role]) => role.default)) !== null && _a !== void 0 ? _a : [];
    if (!roleKey) {
        throw new Error('Default role not found, check your System Role settings');
    }
    return roleKey;
}
/**
 * @deprecated instead use requireAnySystemPermission(userState, 'view-organizations')
 */
export function allowAccessToOrganizations() {
    return true;
}
/**
 * @deprecated instead use requireAnySystemPermission(userState, 'manage-settings')
 */
export function allowAccessToSettings(userState) {
    return requireSystemOrClientAdmin(userState);
}
/**
 * @deprecated instead use requireAnySystemPermission(userState, 'manage-configurable-lists')
 */
export function allowAccessToConfigurableList(userState) {
    return requireSystemAdmin(userState);
}
/**
 * @deprecated instead use requireAnySystemPermission(userState, 'manage-editable-pages')
 */
export function allowAccessToPagesManagement(userState) {
    return requireSystemOrClientAdmin(userState);
}
/**
 * @deprecated - permissions by role are deprecated use requireAnySystemPermission
 * instead use requireAnySystemPermission(userState, "import-account")
 */
export function allowImportBatch(userState) {
    return requireSystemOrClientAdmin(userState);
}
/**
 * @deprecated - permissions by role are deprecated use requireAnySystemPermission
 * instead use requireAnySystemPermission(userState, "export-account")
 */
export function allowExport(userState) {
    return requireSystemOrClientAdmin(userState);
}
/**
 * @deprecated - permissions by role are deprecated use requireAnySystemPermission
 */
export function adminOrSelf(userState, accountId) {
    return requireSystemOrClientAdmin(userState) || (!!accountId && (userState === null || userState === void 0 ? void 0 : userState.id) === accountId);
}
/**
 * @deprecated - permissions by role are deprecated use requireAnySystemPermission instead
 */
export function requireSystemOrClientAdmin(userState) {
    return userState != null && (userState.systemRole === 'system-admin' || userState.systemRole === 'client-admin');
}
/**
 * @deprecated - permissions by role are deprecated use requireAnySystemPermission instead
 */
export function requireSystemAdmin(userState) {
    return userState != null && userState.systemRole === 'system-admin';
}
/**
 * @deprecated - permissions by role are deprecated use requireAnySystemPermission instead
 */
export function requireClientAdmin(userState) {
    return userState != null && userState.systemRole === 'client-admin';
}
